var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningPayoutMulti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7659_50475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.46875C3.61875 0.46875 0.46875 3.61875 0.46875 7.5C0.46875 11.3812 3.61875 14.5312 7.5 14.5312C11.3812 14.5312 14.5312 11.3812 14.5312 7.5C14.5312 3.61875 11.3812 0.46875 7.5 0.46875ZM7.5 11.7188C6.98438 11.7188 6.5625 11.2969 6.5625 10.7812C6.5625 10.2656 6.98438 9.84375 7.5 9.84375C8.01562 9.84375 8.4375 10.2656 8.4375 10.7812C8.4375 11.2969 8.01562 11.7188 7.5 11.7188ZM8.57344 4.44844L8.25938 8.20781C8.22656 8.60156 7.89844 8.90625 7.5 8.90625C7.10156 8.90625 6.77344 8.60156 6.74062 8.20781L6.42656 4.44844C6.375 3.82031 6.86719 3.28125 7.5 3.28125C8.1 3.28125 8.57812 3.76875 8.57812 4.35938C8.57812 4.3875 8.57812 4.42031 8.57344 4.44844Z",
    fill: "#C33025"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7659_50475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningPayoutMulti);
export default __webpack_public_path__ + "static/media/warning-payout-multi.7001f5705ee98d907f118e0613e57a6e.svg";
export { ForwardRef as ReactComponent };